<template>
    <div v-if="user.data" class="container meal_plans_page">
        <h1>{{ $t('meal_plans.title') }}</h1>

        <form class="new_plan_form" @submit.prevent="createPlan()">
            <input
                type="text"
                v-model="new_plan_name"
                :placeholder="$t('meal_plans.name_placeholder')"
                maxlength="60"
            />
            <button type="submit" class="primary_btn" :disabled="!new_plan_name.trim()">{{ $t('meal_plans.create') }}</button>
        </form>
        <p class="error_text" v-if="error">{{ error }}</p>

        <p v-if="!loading && plans.length < 1" class="empty_text">{{ $t('meal_plans.empty') }}</p>

        <div class="row">
            <div class="col-sm-6 col-md-4" v-for="plan in plans" :key="plan.id">
                <div class="plan_card">
                    <router-link :to="'/meal-plans/' + plan.id" class="no_extra_styling">
                        <h3>{{ plan.name }}</h3>
                        <p class="plan_meta">{{ $tc('meal_plans.entry_count', plan.entries.length, { count: plan.entries.length }) }}</p>
                    </router-link>
                    <button type="button" class="delete_link" @click="plan_to_delete = plan">{{ $t('meal_plans.delete') }}</button>
                </div>
            </div>
        </div>

        <ActionModal v-if="plan_to_delete"
            :title="$t('meal_plans.delete_confirm_title')"
            :description="plan_to_delete.name"
            :action_btn="$t('meal_plans.delete')"
            :back_btn="$t('meal_plans.back')"
            btn_type="warning_btn"
            v-on:accept-action="deletePlan()"
            v-on:decline-action="plan_to_delete = null"
        />
    </div>
    <div v-else>
        <h1>Δεν έχεις συνδεθεί.</h1>
        <router-link to="/login?fwd=/meal-plans" class="primary_btn add_recipe">Σύνδεση ή Εγγραφή</router-link>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionModal from './extras/Action_modal.vue';

export default {
    name: 'MealPlans',
    components: {
        ActionModal
    },
    data() {
        return {
            plans: [],
            new_plan_name: "",
            plan_to_delete: null,
            loading: true,
            error: null
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        })
    },
    watch: {
        "$store.getters.user.data": function () {
            if (this.user.data) {
                this.getPlans();
            }
        }
    },
    mounted() {
        if (this.user.data) {
            this.getPlans();
        }
    },
    methods: {
        getPlans() {
            fetch(process.env.VUE_APP_API + `/mealplans`, {
                headers: {
                    "TOKEN": JSON.stringify(this.user.data.token)
                }
            }).then(res => res.json())
              .then(res => {
                  this.loading = false;
                  if (res.error) {
                      this.error = res.error;
                  } else {
                      this.plans = res;
                  }
              });
        },
        createPlan() {
            this.error = null;
            fetch(process.env.VUE_APP_API + `/mealplans`, {
                method: "post",
                headers: {
                    "TOKEN": JSON.stringify(this.user.data.token),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ plan: { name: this.new_plan_name } })
            }).then(res => res.json())
              .then(res => {
                  if (res.error) {
                      this.error = res.error;
                  } else {
                      this.$router.push('/meal-plans/' + res.plan.id);
                  }
              });
        },
        deletePlan() {
            let plan = this.plan_to_delete;
            this.plan_to_delete = null;
            fetch(process.env.VUE_APP_API + `/mealplans/` + plan.id, {
                method: "delete",
                headers: {
                    "TOKEN": JSON.stringify(this.user.data.token)
                }
            }).then(res => res.json())
              .then(res => {
                  if (res.error) {
                      this.error = res.error;
                  } else {
                      this.plans = this.plans.filter((p) => p.id !== plan.id);
                  }
              });
        }
    }
}
</script>

<style scoped>
.meal_plans_page {
    text-align: left;
    padding-top: 2rem;
}
.new_plan_form {
    display: flex;
    gap: 0.5rem;
    margin: 1.5rem 0;
    max-width: 500px;
}
.new_plan_form input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid var(--color-grey-1);
    border-radius: 6px;
    background-color: transparent;
    color: inherit;
}
.plan_card {
    border: 1px solid var(--color-grey-1);
    border-radius: 6px;
    padding: 1rem;
    margin: 0.6rem 0;
}
.plan_card:hover {
    border-color: var(--color-secondary);
}
.plan_meta {
    color: var(--color-grey-2);
    font-size: 0.9rem;
    margin-bottom: 0;
}
.delete_link {
    background: none;
    border: none;
    padding: 0;
    margin-top: 0.5rem;
    color: var(--color-grey-2);
    font-size: 0.85rem;
    cursor: pointer;
    text-decoration: underline;
}
.delete_link:hover {
    color: var(--color-secondary);
}
.empty_text, .error_text {
    color: var(--color-grey-2);
}
</style>
